import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[ui-button-dark]',
})
export class UiButtonDarkDirective {
  constructor() {}
  @HostBinding('class') elementClass = 'ui-button-dark';
}
